import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { getLocalChargesAndDiscount, getLocalPriceCode, getStoreLocalData, getUserData, setLocalPriceCode } from "../../../utils/localStorage";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { storeCustomerGetInfo } from "../../../services/CustomerInfo/CustomerInfo";
import { customerAddressGet } from "../../../services/CustomerInfo/EditCustomer";
import EditCustomerNameModal from "./EditCustomerNameModal";
import EditCustomerModal from "./EditCustomerModal";
import CreateCustomerAddressModal from "./CreateCustomerAddressModal";
import EditCustomerAddressChange from "./EditCustomerAddressChange";
import EditCustomerNotification from "./EditCustomerNotification";
import EditCustomerAddressModal from "./EditCustomerAddressModal";
import EditCustomerLocationModal from "./EditCustomerLocationModal";
import StoreMenu from "../../StoreMenu";
import EditCustomerSourceModal from "./EditCustomerSourceModal";
import EditCustomerIdModal from "./EditCustomerIdModal";
import ButtonLink from "../../../ButtonLink";
import { getBrandStoreById } from "../../../services/StoreUsers/PostStoreUsers";
import AdminMenu from "../../AdminMenu";
import EditCustomerChargeModalAdmin from "./EditCustomerChargeModalAdmin";
import { getChargesAndDiscount } from "../../../services/Cart/getChargesAndDiscount";
import { getPriceCode } from "../../../services/StorePriceCode/getPriceCode";
import EditCustomerGeneralBookingPriceListSelection from "./EditCustomerGeneralBookingPriceListSelection";

const EditCustomerAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, storeCustomerId, storeId } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData } = getUserData();

  const [storeData, setStoreData] = useState({})

  const enabledLocality = storeData.enabledLocality;
  const enabledAddInternationalCustomer =
    storeData.enabledAddInternationalCustomer;
  const enabledCustomerJeoLocationByAddress = true;
  let brandId = brandProfileData.id;
  const enabledMultiPriceList = storeData.enabledMultiPriceList;
  const enabledCustomerBillingWithDefaultPrice = storeData.enabledCustomerBillingWithDefaultPrice;
  
  const [defaultPriceData, setDefaultPriceData] = useState([]);
    const [
      generalBookingPriceListModalVisible,
      setGeneralBookingPriceListModalVisible,
    ] = useState(false);


  const { storeLocalData } = getStoreLocalData();
  

  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [statusTotalData, setStatusTotalData] = useState([]);
  const [visible, setVisible] = useState(false);

  const [addressItems, setAddressItems] = useState([]);
  const [editCustomerData, setEditCustomerData] = useState({});
  const [activeNotification, setActiveNotification] = useState(null);
  // replace false with the active or inactive value of api
  const [activeAddressItemId, setActiveAddressItemId] = useState(null); // Track the active itemId

  const [editCustomerModalVisible, setEditCustomerModalVisible] =
    useState(false);
  const [editCustomerNameModalVisible, setEditCustomerNameModalVisible] =
    useState(false);
  const [editCustomerSourceModalVisible, setEditCustomerSourceModalVisible] =
    useState(false);
  const [editCustomerIdModalVisible, setEditCustomerIdModalVisible] =
    useState(false);
  const [editCustomerAddressModalVisible, setEditCustomerAddressModalVisible] =
    useState(false);
  const [editCustomerChargeModalVisible, setEditCustomerChargeModalVisible] =
    useState(false);

  const [
    createCustomerAddressModalVisible,
    setCreateCustomerAddressModalVisible,
  ] = useState(false);

  const fetchStoreUser = () => {
       getBrandStoreById(storeId)
         .then((response) => {
           if (!response.data.error) {
             const Res = response.data;
             setStoreData(Res);
           }
         })
         .catch((err) => {
           console.error("Error:", err);
         });
     };

  const fetchStoreCustomerInfo = async () => {
    try {
      const response = await storeCustomerGetInfo(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setEditCustomerData(Res);
        setActiveNotification(Res?.brandCustomer?.notify);
        setActiveAddressItemId(Res?.address?.id || null);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchStoreChargesAndDiscount = async () => {
          try {
            const response = await getChargesAndDiscount(storeId);
            if (!response.data.error) {
              const Res = response.data;
              const [chargeArray, discountArray] = Res.reduce(
                ([charges, discounts], item) => {
                  if (
                    item.chargeDiscountMode === "ALL" ||
                    item.chargeDiscountMode === "BOOKING"
                  ) {
                    if (item.chargeDiscountType === "CHARGE") charges.push(item);
                    if (item.chargeDiscountType === "DISCOUNT")
                      discounts.push(item);
                  }
                  return [charges, discounts];
                },
                [[], []]
              );
  
              setCharges(chargeArray);
              setDiscounts(discountArray);
            }
          } catch (err) {
            console.error("Error:", err);
          }
        };
        
         const fetchDefaultPrice = async () => {
            try {
              const response = await getPriceCode(storeId);
              if (!response.data.error) {
                const Res = response.data;
                setDefaultPriceData(Res.storePrices);
                setLocalPriceCode(Res.storePrices);
              }
            } catch (err) {
              console.error("Error:", err);
            }
          };
        
          const fetchLocalDefaultPrice = async () => {
            const { priceCode } = getLocalPriceCode();
            if (priceCode && Object.keys(priceCode).length > 0) {
              setDefaultPriceData(priceCode);
            } else {
              await fetchDefaultPrice();
            }
          };

  useEffect(() => {
    fetchStoreUser();
    fetchStoreCustomerInfo();
    fetchStoreChargesAndDiscount();
    fetchLocalDefaultPrice();
  }, []);

  const [chargeDiscountType, setChargeDiscountType] = useState("");
  const [charges, setCharges] = useState([]);
  const [discounts, setDiscounts] = useState([]);

  const addChargesData = charges.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const addDiscountsData = discounts.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const addChargeDataNew = addChargesData.filter(
    (charge) => editCustomerData.autoChargeId === charge.chargeDiscountId
  );
  const autoChargeIdValue = addChargeDataNew[0];

  const addDiscountDataNew = addDiscountsData.filter(
    (discount) => editCustomerData.autoDiscountId === discount.chargeDiscountId
  );

  const autoDiscountIdValue = addDiscountDataNew[0];

  const fetchData = async () => {
    try {
      const response = await customerAddressGet(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setAddressItems(Res);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    storeCustomerId,
    storeId,
    editCustomerAddressModalVisible,
    createCustomerAddressModalVisible,
    editCustomerModalVisible,
    editCustomerNameModalVisible,
  ]);

  const receiveDataFromModal = ({ success }) => {
    if (success) {
      fetchStoreCustomerInfo();
      fetchData();
    }
  };

  const CustomerInformation = {
    firstName: editCustomerData?.brandCustomer?.firstName
      ? editCustomerData?.brandCustomer?.firstName
      : "",
    lastName: editCustomerData?.brandCustomer?.lastName
      ? editCustomerData?.brandCustomer?.lastName
      : null,
    mobile: editCustomerData?.brandCustomer?.mobile
      ? editCustomerData?.brandCustomer?.mobile
      : "",
    email: editCustomerData?.brandCustomer?.email
      ? editCustomerData?.brandCustomer?.email
      : "",
    gstNo: editCustomerData?.brandCustomer?.gstNo
      ? editCustomerData?.brandCustomer?.gstNo
      : "",
    notify: editCustomerData?.brandCustomer?.notify
      ? editCustomerData?.brandCustomer?.notify
      : editCustomerData?.brandCustomer?.notify,
    registrationDate: editCustomerData?.brandCustomer?.createdDate
      ? formatDate(editCustomerData?.brandCustomer?.createdDate)
      : "",

    currentLocation: editCustomerData?.address?.currentLocation,
    addressLatitude: editCustomerData?.address?.latitude,
    addressLongitude: editCustomerData?.address?.longitude,
    source: editCustomerData?.brandCustomer?.source,
    customerId: editCustomerData?.customerId,
    autoChargeId: editCustomerData.autoChargeId,
    autoDiscountId: editCustomerData.autoDiscountId,
    priceId: editCustomerData?.priceId,
  };

  const [editField, setEditField] = useState(""); // To store the field name being edited
  const [editValue, setEditValue] = useState(""); // To store the edited value
  const [editIcon, setEditIcon] = useState(""); // To store the edited value

  const [nameEditField, setNameEditField] = useState(""); // To store the field name being edited
  const [nameEditValue, setNameEditValue] = useState(""); // To store the edited value
  const [lastNameEditValue, setLastNameEditValue] = useState(""); // To store the edited value
  const [nameEditIcon, setNameEditIcon] = useState(""); // To store the edited value

  const [sourceName, setSourceName] = useState(""); // To store the edited value

  const [selectedAddressItem, setSelectedAddressItem] = useState(null);
  const [editAddressFieldName, setEditAddressFieldName] = useState(""); // To store the field name being edited
  const [editAddressFieldCount, setEditAddressFieldCount] = useState(""); // To store the field name being edited
  const [addressLineEditValue1, setAddressLineEditValue1] = useState(""); // To store the edited value
  const [addressLineEditValue2, setAddressLineEditValue2] = useState(""); // To store the edited value
  const [addressCityEditValue, setAddressCityEditValue] = useState(""); // To store the edited value
  const [addressStateEditValue, setAddressStateEditValue] = useState(""); // To store the edited value
  const [addressLandmarkEditValue, setAddressLandmarkEditValue] = useState(""); // To store the edited value
  const [addressPinEditValue, setAddressPinEditValue] = useState(""); // To store the edited value
  const [addressEditIcon, setAddressEditIcon] = useState(""); // To store the edited value

  const [chargeName, setChargeName] = useState(null);
  const [discountName, setDiscountName] = useState(null);

  const [editCurrentLocation, setEditCurrentLocation] = useState("");
  const [editLatitude, setEditLatitude] = useState("");
  const [editLongitude, setEditLongitude] = useState("");
  const [
    editCustomerCurrentLocationModalVisible,
    setEditCustomerCurrentLocationModalVisible,
  ] = useState(false);

  const handleEdit = (fieldName, fieldValue, Icon) => {
    setEditField(fieldName);
    setEditValue(fieldValue);
    setEditIcon(Icon);

    setEditCustomerModalVisible(true);
  };

  const handleNameEdit = (
    fieldNameName,
    fieldNameValue,
    fieldLastNameValue,
    IconName
  ) => {
    setNameEditField(fieldNameName);
    setNameEditValue(fieldNameValue);
    setLastNameEditValue(fieldLastNameValue);
    setNameEditIcon(IconName);

    setEditCustomerNameModalVisible(true);
  };

  const handleAddressCreate = () => {
    setCreateCustomerAddressModalVisible(true);
  };

  const handleAddressEdit = (
    fieldAddressCount,
    fieldAddressName,
    fieldAddressLineValue1,
    fieldAddressLineValue2,
    fieldAddressCity,
    fieldAddressState,
    fieldAddressLandmark,
    fieldAddressPin,
    IconName
  ) => {
    setEditAddressFieldCount(fieldAddressCount);
    setEditAddressFieldName(fieldAddressName);
    setAddressLineEditValue1(fieldAddressLineValue1);
    setAddressLineEditValue2(fieldAddressLineValue2);
    setAddressCityEditValue(fieldAddressCity);
    setAddressStateEditValue(fieldAddressState);
    setAddressLandmarkEditValue(fieldAddressLandmark);
    setAddressPinEditValue(fieldAddressPin);
    setAddressEditIcon(IconName);

    setEditCustomerAddressModalVisible(true);
  };

  const handleCurrentLocationEdit = (
    fieldCurrentLocation,
    fieldLatitude,
    fieldLongitude,
    IconName
  ) => {
    setEditCurrentLocation(fieldCurrentLocation);
    setEditLatitude(fieldLatitude);
    setEditLongitude(fieldLongitude);
    setAddressEditIcon(IconName);

    setEditCustomerCurrentLocationModalVisible(true);
  };

  const [selectedPriceIdName, setSelectedPriceIdName] = useState([]);
    useEffect(() => {
      if(defaultPriceData && CustomerInformation?.priceId) {
        const selectedPriceId = defaultPriceData?.filter(
          (item) => item?.price?.id === CustomerInformation?.priceId,
        );
        
        setSelectedPriceIdName(selectedPriceId);
      }
    }, [defaultPriceData, CustomerInformation?.priceId]);

  const renderAddressData = () => {
    return addressItems?.map((item, index) => (
      <div>
        <div className="flex flex-row">
          <div
            className="flex-1 px-2 py-1"
            style={{
              backgroundColor: index % 2 === 0 ? "#F8FFEE" : "#E2F4F8",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <p className=" text-lg  font-normal ">
                  <i
                    className="pi pi-map-marker"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#ff5454",
                    }}
                  ></i>
                  Address {index + 1}:
                </p>
                <div
                  onClick={() => {
                    handleAddressEdit(
                      index,
                      "Address " + item.id,
                      item.addressLine1,
                      item.addressLine2,
                      item.city,
                      item.state,
                      item.landmark,
                      item.pin,
                      <i
                        className="pi pi-map-marker"
                        style={{
                          fontSize: "20px",
                          marginRight: 10,
                          color: "#ff5454",
                        }}
                      ></i>
                    );
                    setSelectedAddressItem(item);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                    }}
                  ></i>
                </div>
              </div>
              <div className="flex-1 flex-row flex-wrap mr-2">
                <p className=" text-xl  font-medium ">
                  {item.addressLine1 && `${item.addressLine1}`}
                  {item.addressLine2 && `, ${item.addressLine2}`}
                  {item.city && `, ${item.city}`}
                  {item.state && `, ${item.state}`}
                  {item.landmark && `, ${item.landmark}`}
                  {item.pin && `, ${item.pin}`}
                </p>
              </div>
            </div>
          </div>
          <div
            className="px-4 py-1"
            style={{
              backgroundColor: index % 2 === 0 ? "#F8FFEE" : "#E2F4F8",
            }}
          >
            <EditCustomerAddressChange
              activeAddressStatus={activeAddressItemId === item.id} // Check if this item is active
              setActiveAddressStatus={setActiveAddressItemId}
              itemId={item.id} // Pass the itemId
              addressDetail={item}
              storeId={storeId}
              editCustomerData={editCustomerData}
              sendDataToEditCustomer={receiveDataFromModal}
            />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/CustomerInfo", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        storeId: storeId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Customer Info
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between mx-4">
          <div className="py-1">
            <p className=" text-2xl  font-bold ">Basic Info</p>
          </div>
        </div>
      </div>
      <div className="flex-1">
        <div className="mx-3 my-3 surface-0" style={{ "--surface-0": "#fff" }}>
          <div className="flex flex-row">
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#E2F4F8" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-user"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  Name :
                </p>
                <div
                  onClick={() =>
                    handleNameEdit(
                      "Name",
                      CustomerInformation.firstName,
                      CustomerInformation.lastName,
                      <i
                        className="pi pi-bars"
                        style={{
                          fontSize: "20px",
                          marginRight: 10,
                          color: "#76a632",
                        }}
                      ></i>
                    )
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.firstName} {CustomerInformation.lastName}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#F8FFEE" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-envelope"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>{" "}
                  Email :
                </p>
                <div
                  onClick={() =>
                    handleEdit(
                      "Email",
                      CustomerInformation.email,
                      <i
                        className="pi pi-envelope"
                        style={{
                          fontSize: "20px",
                          marginRight: 10,
                          color: "#76a632",
                        }}
                      ></i>
                    )
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium " numberOfLines={2}>
                {CustomerInformation.email}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#E2F4F8" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-mobile"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>{" "}
                  Mobile No. :
                </p>
                <div
                  onClick={() =>
                    handleEdit(
                      "Mobile No.",
                      CustomerInformation.mobile,
                      <i
                        className="pi pi-mobile"
                        style={{
                          fontSize: "20px",
                          marginRight: 10,
                          color: "#76a632",
                        }}
                      ></i>
                    )
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.mobile}
              </p>
            </div>
          </div>
          <div className="flex flex-row">
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#F8FFEE" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-file"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  {storeLocalData?.taxType} No. :
                </p>

                <div
                  onClick={() =>
                    handleEdit(
                      storeLocalData?.taxType,
                      CustomerInformation.gstNo,
                      <i
                        className="pi pi-file"
                        style={{
                          fontSize: "20px",
                          marginRight: 10,
                          color: "#76a632",
                        }}
                      ></i>
                    )
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.gstNo}
              </p>
            </div>

            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#E2F4F8" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-calendar"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>{" "}
                  Registration Date:
                </p>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.registrationDate}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#F8FFEE" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-file"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  Source :
                </p>

                <div
                  onClick={() => {
                    setEditCustomerSourceModalVisible(true);
                    setSourceName(CustomerInformation.source);
                  }}
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.source}
              </p>
            </div>
          </div>
          <div className="flex flex-row">
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#E2F4F8" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-user"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  Customer Id :
                </p>
                <div onClick={() => setEditCustomerIdModalVisible(true)}>
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {CustomerInformation.customerId}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#F8FFEE" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-file"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  Discount :
                </p>

                <div
                  onClick={() => {
                    setEditCustomerChargeModalVisible(true);
                    setDiscountName(CustomerInformation.autoDiscountId);
                    setChargeDiscountType("Discount");
                  }}
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">
                {autoDiscountIdValue?.name}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-2 surface-0"
              style={{ "--surface-0": "#E2F4F8" }}
            >
              <div className="flex-row justify-content-between ">
                <p
                  className="text-lg  font-medium "
                  style={{ color: "#75879B" }}
                >
                  <i
                    className="pi pi-file"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#76a632",
                    }}
                  ></i>
                  Charge :
                </p>

                <div
                  onClick={() => {
                    {
                      setEditCustomerChargeModalVisible(true);
                      setChargeName(CustomerInformation.autoChargeId);
                      setChargeDiscountType("Charge");
                    }
                  }}
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      marginRight: 10,
                      color: "#1752AA",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-xl  font-medium ">{autoChargeIdValue?.name}</p>
            </div>
          </div>
          {defaultPriceData.length > 1 && enabledMultiPriceList && enabledCustomerBillingWithDefaultPrice && (
            <div className="flex flex-row">
              <div
                className="flex-1 px-3 py-2 surface-0"
                style={{ "--surface-0": "#F8FFEE" }}
              >
                <div className="flex-row justify-content-between ">
                  <p
                    className="text-lg  font-medium "
                    style={{ color: "#75879B" }}
                  >
                    <i
                      className="pi pi-file"
                      style={{
                        fontSize: "20px",
                        marginRight: 10,
                        color: "#76a632",
                      }}
                    ></i>
                    Price Id:
                  </p>

                  <div
                    onClick={() => {
                      setGeneralBookingPriceListModalVisible(true);
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "20px",
                        marginRight: 10,
                        color: "#1752AA",
                        cursor: "pointer",
                      }}
                    ></i>
                  </div>
                </div>
                <p className="text-xl  font-medium ">
                  {selectedPriceIdName[0]?.price?.priceCode}
                </p>
              </div>

              <div
                className="flex-1 px-3 py-2 surface-0"
                style={{ "--surface-0": "#E2F4F8" }}
              ></div>
              <div
                className="flex-1 px-3 py-2 surface-0"
                style={{ "--surface-0": "#F8FFEE" }}
              ></div>
            </div>
          )}
        </div>
      </div>
      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between mx-4">
          <div className="py-1">
            <p className=" text-2xl  font-bold ">Address</p>
          </div>
        </div>
      </div>
      <div className="flex-1">
        <div>
          <div>
            <div
              onClick={() => {
                handleAddressCreate();
              }}
              style={{ cursor: "pointer" }}
              className="flex flex-row justify-content-end mx-3 my-3"
            >
              {/* Noida-105 will come through the api*/}
              <p className="text-xl  font-bold ">Add New Address</p>

              <i
                className="pi pi-plus-circle"
                style={{ fontSize: "25px", marginLeft: 10, color: "#1752AA" }}
              ></i>
            </div>
          </div>
          <div
            className="mx-3 my-3 surface-0"
            style={{ "--surface-0": "#fff" }}
          >
            {renderAddressData()}
          </div>
        </div>
      </div>
      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between mx-4">
          <div className="py-1">
            <p className=" text-2xl  font-bold ">Geo Location</p>
          </div>
        </div>
      </div>
      <div className="mx-3 my-3 surface-0" style={{ "--surface-0": "#fff" }}>
        <div className="flex flex-row">
          <div
            className="flex-1 px-2 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p className=" text-lg  font-normal ">
                <i
                  className="pi pi-map-marker"
                  style={{
                    fontSize: "20px",
                    marginRight: 10,
                    color: "#ff5454",
                  }}
                ></i>{" "}
                Location :
              </p>
              <div
                onClick={() =>
                  handleCurrentLocationEdit(
                    CustomerInformation.currentLocation,
                    CustomerInformation.addressLatitude,
                    CustomerInformation.addressLongitude,
                    <i
                      className="pi pi-map-marker"
                      style={{
                        fontSize: "25px",
                        marginLeft: 10,
                        color: "#ff5454",
                      }}
                    ></i>
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <i
                  className="pi pi-pencil"
                  style={{
                    fontSize: "20px",
                    marginRight: 10,
                    color: "#1752AA",
                  }}
                ></i>
              </div>
            </div>
            {CustomerInformation.currentLocation && (
              <p className=" text-xl  font-medium ">
                {CustomerInformation.currentLocation}
              </p>
            )}
            {CustomerInformation.addressLatitude && (
              <p className=" text-xl  font-medium ">
                Latitude : {CustomerInformation.addressLatitude}
              </p>
            )}
            {CustomerInformation.addressLongitude && (
              <p className=" text-xl  font-medium ">
                Longitude : {CustomerInformation.addressLongitude}
              </p>
            )}
          </div>
        </div>
      </div>
      {enabledCustomerJeoLocationByAddress && editCustomerData?.address?.latitude && editCustomerData?.address?.longitude &&
        <div className="m-3">

          <iframe
            title="Google Map"
            width="100%"
            height="450"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            src={`https://maps.google.com/maps?q=${editCustomerData?.address?.latitude},${editCustomerData?.address?.longitude}&z=15&output=embed`}
          />
        </div>
      }
      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between align-items-center mx-4">
          <p className=" text-2xl  font-bold ">Notification</p>
          <EditCustomerNotification
            activeNotification={activeNotification}
            setActiveNotification={setActiveNotification}
            editCustomerData={editCustomerData}
          />
        </div>
      </div>
      <div style={{ marginBottom: 20 }}></div>
      <EditCustomerModal
        setEditCustomerModalVisible={setEditCustomerModalVisible}
        editCustomerModalVisible={editCustomerModalVisible}
        fieldName={editField}
        fieldValue={editValue}
        editIcon={editIcon}
        editCustomerData={editCustomerData}
        sendDataToEditCustomer={receiveDataFromModal}
        enabledAddInternationalCustomer={enabledAddInternationalCustomer}
        // handleEditData={handleEditData}
      />
      <EditCustomerNameModal
        setEditCustomerNameModalVisible={setEditCustomerNameModalVisible}
        editCustomerNameModalVisible={editCustomerNameModalVisible}
        fieldNameName={nameEditField}
        fieldNameValue={nameEditValue}
        fieldLastNameValue={lastNameEditValue}
        nameEditIcon={nameEditIcon}
        editCustomerData={editCustomerData}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      <EditCustomerSourceModal
        setEditCustomerSourceModalVisible={setEditCustomerSourceModalVisible}
        editCustomerSourceModalVisible={editCustomerSourceModalVisible}
        sourceName={sourceName}
        editCustomerData={editCustomerData}
        storeId={storeId}
        sendDataToEditCustomer={receiveDataFromModal}
      />

      <EditCustomerChargeModalAdmin
        setEditCustomerChargeModalVisible={setEditCustomerChargeModalVisible}
        editCustomerChargeModalVisible={editCustomerChargeModalVisible}
        chargeName={chargeName}
        discountName={discountName}
        chargeDiscountType={chargeDiscountType}
        editCustomerData={editCustomerData}
        storeId={storeId}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      
      <EditCustomerIdModal
        setEditCustomerIdModalVisible={setEditCustomerIdModalVisible}
        editCustomerIdModalVisible={editCustomerIdModalVisible}
        customerIdName={editCustomerData?.customerId}
        editCustomerData={editCustomerData}
        storeId={storeId}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      <CreateCustomerAddressModal
        setCreateCustomerAddressModalVisible={
          setCreateCustomerAddressModalVisible
        }
        createCustomerAddressModalVisible={createCustomerAddressModalVisible}
        editCustomerData={editCustomerData}
        storeCustomerId={storeCustomerId}
        sendDataToEditCustomer={receiveDataFromModal}
        brandId={brandId}
        enabledLocality={enabledLocality}
      />
      <EditCustomerAddressModal
        setEditCustomerAddressModalVisible={setEditCustomerAddressModalVisible}
        editCustomerAddressModalVisible={editCustomerAddressModalVisible}
        editAddressFieldCount={editAddressFieldCount}
        editAddressFieldName={editAddressFieldName}
        addressLineEditValue1={addressLineEditValue1}
        addressLineEditValue2={addressLineEditValue2}
        addressCityEditValue={addressCityEditValue}
        addressStateEditValue={addressStateEditValue}
        addressLandmarkEditValue={addressLandmarkEditValue}
        addressPinEditValue={addressPinEditValue}
        addressEditIcon={addressEditIcon}
        addressItems={addressItems}
        selectedAddressItem={selectedAddressItem}
        editCustomerData={editCustomerData}
        storeCustomerId={storeCustomerId}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      <EditCustomerLocationModal
        setEditCustomerCurrentLocationModalVisible={
          setEditCustomerCurrentLocationModalVisible
        }
        editCustomerCurrentLocationModalVisible={
          editCustomerCurrentLocationModalVisible
        }
        editCurrentLocation={editCurrentLocation}
        editLatitude={editLatitude}
        editLongitude={editLongitude}
        editCustomerData={editCustomerData}
        addressEditIcon={addressEditIcon}
        storeCustomerId={storeCustomerId}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      <EditCustomerGeneralBookingPriceListSelection
        setGeneralBookingPriceListModalVisible={
          setGeneralBookingPriceListModalVisible
        }
        generalBookingPriceListModalVisible={
          generalBookingPriceListModalVisible
        }
        priceData={defaultPriceData}
        editCustomerData={editCustomerData}
        sendDataToEditCustomer={receiveDataFromModal}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default EditCustomerAdmin;
